let flexibleLoaded = false;

export async function manageFlexible() {
  const shouldLoad = window.location.href.includes('mo/');

  if (shouldLoad && !flexibleLoaded) {
    if (!window.lib?.flexible) {
      await new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = process.env.BASE_URL + 'mobileFlexIble.js';
        script.onload = () => {
          const meta = document.createElement('meta');
          meta.name = 'viewport';
          meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover';
          document.head.appendChild(meta);
          
          window.lib?.flexible?.refreshRem();
          resolve();
        };
        document.head.appendChild(script);
      });
      flexibleLoaded = true;
    }
  } else if (!shouldLoad && flexibleLoaded) {
    if (window.lib?.flexible) {
      delete window.lib.flexible;
    }
    const docEl = document.documentElement;
    docEl.removeAttribute('data-dpr');
    docEl.style.fontSize = '';
    document.body.style.fontSize = '';
    const viewportMeta = document.querySelector('meta[name="viewport"][content*="initial-scale"]');
    if (viewportMeta) {
      viewportMeta.remove();
    }
    flexibleLoaded = false;
  }
}

let lastUrl = location.href;
new MutationObserver(() => {
  if (location.href !== lastUrl) {
    lastUrl = location.href;
    manageFlexible();
  }
}).observe(document, {subtree: true, childList: true});